import Button from 'components/shared/Button/Button';

import renderButton from '../../components/renderButton';

const Footer = ({ isFooter, footer, footerActions, handleClose, variant }) => {
  if (!isFooter) return null;

  if (typeof footer === 'object') {
    return <div className="flex flex-wrap-reverse justify-end gap-3 px-4 py-3">{footer}</div>;
  }

  const otherContent = footerActions?.keepEditing ? (
    <Button
      size="small"
      className="text-xs text-neutral-700"
      variant="link"
      color="neutral"
      icon="edit-2-mono"
      iconColor="neutral"
      text="Keep editing"
      onClick={handleClose}
    />
  ) : (
    footerActions?.other
  );

  // If footerActions has a primary button color add it, otherwise use the modal variant for the primary button
  const primaryButton = footerActions?.primary
    ? { ...footerActions.primary, color: footerActions.primary.color || variant }
    : footerActions?.primary;

  const secondaryButton =
    footerActions?.secondary === undefined
      ? {
          text: 'Cancel',
          onClick: handleClose,
          color: 'neutral',
          style: 'outlined'
        }
      : footerActions?.secondary;

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3">
      <div className="flex items-center">{otherContent}</div>
      <div className="ml-auto flex flex-wrap-reverse items-center gap-3">
        {renderButton({
          config: secondaryButton,
          defaultText: 'Cancel',
          defaultVariant: 'tertiary',
          defaultOnClick: handleClose,
          defaultDataQa: 'close-confirm-modal-btn'
        })}
        {renderButton({
          config: primaryButton,
          defaultText: 'Confirm',
          defaultVariant: 'primary',
          defaultDataQa: 'proceed-confirm-modal-btn'
        })}
      </div>
    </div>
  );
};

export default Footer;
